export default __webpack_public_path__ + "static/media/logo-mindgrapher-negative.39c98d1d.png";